//
import React, { useEffect, useState, useCallback } from "react";
import WingForm from "./ExportWingForm";
import axios from "axios";
import { getURLbyEndPointV2 } from "../../../../store/api";
import { getAuthUserlocal } from "../../../../store/services";

const ExportWing = () => {
  const [formData, setFormData] = useState({
    wing: "Export",
    query: "",
    topic: "null",
    summary: "",
    refDoc: null,
  });
  const [wingApiFlag, setWingApiFlag] = useState(false);
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);
  const userId = getAuthUserlocal()?._id;

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    if (
      !formData.wing ||
      !formData.query ||
      !formData.topic ||
      !formData.summary
    ) {
      alert("Please Fill Form Correctly");
      return;
    }

    if (!isCaptchaCorrect) {
      alert("Please Fill Correct Captcha");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("wing", formData.wing);
    formDataToSend.append("query", formData.query);
    formDataToSend.append("topic", formData.topic);
    formDataToSend.append("summary", formData.summary);

    if (formData.refDoc) {
      formDataToSend.append("refDoc", formData.refDoc);
    }

    try {
      setWingApiFlag(true);

      const res = await axios.post(
        getURLbyEndPointV2("createQuery") + userId,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status) {
        alert("Query created success");
        setWingApiFlag(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error while creting query export wing:", error);
      alert("Error while creting query export wing. Please try again.");
    } finally {
      setWingApiFlag(false);
    }
  };

  return (
    <WingForm
      wing="Export Wing"
      title="EXPORT WING-Online Consultation / Query Notes"
      formData={formData}
      isCaptchaCorrect={isCaptchaCorrect}
      setIsCaptchaCorrect={setIsCaptchaCorrect}
      wingApiFlag={wingApiFlag}
      setFormData={setFormData}
      handleSubmitForm={handleSubmitForm}
    />
  );
};

export default ExportWing;
